module.exports = __webpack_public_path__ + "img/customer_shjc.836a4bc0.svg";